<div [class.active]="isBooked">
  <div class="icon">
    <i class="cs-icon cs-icon-pc"></i>
  </div>
  <div class="date" [matTooltip]="$safeNavigationMigration(inquiry?.booked) | epoch" matTooltipPosition="above">
    {{ $safeNavigationMigration(inquiry?.booked) | epoch : 'D MMM YYYY' }}
  </div>
  <div class="info text-light">
    <i class="fas fa-check-circle text-success"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Reserved</ng-container>
  </div>
</div>

<div [class.active]="isBooked && isCheckedIn">
  <div class="icon">
    <i class="cs-icon cs-icon-checkin-door"></i>
  </div>
  <div
    class="date"
    matTooltip="{{ $safeNavigationMigration(inquiry?.guestArrive) | epochUTC : 'DD - MMM - YYYY' }} | {{
      $safeNavigationMigration((checkInout$ | async)?.checkIn) | epoch : 'h:mm A'
    }}"
    matTooltipPosition="above"
  >
    {{ $safeNavigationMigration(inquiry?.guestArrive) | epochUTC : 'D MMM YYYY' }}
  </div>
  <div class="info text-light">
    <i class="fas fa-check-circle text-success"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Check In</ng-container>
  </div>
</div>

<div [class.active]="isBooked && isCheckedOut">
  <div class="icon">
    <i class="cs-icon cs-icon-checkout-door"></i>
  </div>
  <div
    class="date"
    matTooltip="{{ $safeNavigationMigration(inquiry?.guestDepart) | epochUTC : 'DD - MMM - YYYY' }} | {{
      $safeNavigationMigration((checkInout$ | async)?.checkOut) | epoch : 'h:mm A'
    }}"
    matTooltipPosition="above"
  >
    {{ $safeNavigationMigration(inquiry?.guestDepart) | epochUTC : 'D MMM YYYY' }}
  </div>
  <div class="info text-light">
    <i class="fas fa-check-circle text-success"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Check Out</ng-container>
  </div>
</div>
